<ng-container>
  <ng-container *ngIf="!errorOcurred" [ngTemplateOutlet]="commonContent"></ng-container>
  <app-error-msg *ngIf="errorOcurred" [type]="errorOcurred"></app-error-msg>
</ng-container>

<ng-template #commonContent>
  <app-spinner [showText]="true" *ngIf="isLoading"></app-spinner>
  <div *ngIf="extraInfo?.individualObservation && !isLoading" class="container container-individualobservations">
    <div class="grid-fixed grid-lite total-vacations-detail">
      <ng-container [ngTemplateOutlet]="individualObservations"></ng-container>
    </div>
  </div>
  <div *ngIf="extraInfo?.storeInfo?.length && !isLoading" class="container container-extrainfo">
    <div
      *ngFor="let storeInfo of extraInfo?.storeInfo; trackBy: trackByItems"
      class="grid-fixed grid-lite total-vacations-detail store-info">
      <ng-container [ngTemplateOutlet]="StoreInfo" [ngTemplateOutletContext]="{ storeInfo: storeInfo }"></ng-container>
    </div>
  </div>
  <div *ngIf="extraInfo?.lastModified && !isLoading" class="container container-lastmodified">
    <div class="grid-fixed grid-lite total-vacations-detail">
      <ng-container [ngTemplateOutlet]="LastModifiedDate"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #individualObservations>
  <div class="row total-vacations-detail__title-row storeInfo__title">
    <div size="12" class="col total-vacations-detail__header no-padding">
      <span>{{ 'MOT.VACATIONS.DETAIL.INDIVIDUAL_REMARKS' | translate }}</span>
    </div>
  </div>
  <div class="row total-vacations-detail__title-row">
    <div size="12" class="col total-vacations-detail__title no-padding">
      <span>{{ extraInfo?.individualObservation }} </span>
    </div>
  </div>
</ng-template>

<ng-template #StoreInfo let-storeInfo="storeInfo">
  <div
    *ngIf="storeInfo.store?.codeLabel || storeInfo.store?.name"
    class="row total-vacations-detail__title-row storeInfo__title">
    <div size="12" class="col total-vacations-detail__header no-padding">
      <span *ngIf="storeInfo.store?.codeLabel">{{ storeInfo.store?.codeLabel }} </span>
      <span *ngIf="storeInfo.store?.codeLabel && storeInfo.store?.name"> - </span>
      <span *ngIf="storeInfo.store?.name">{{ storeInfo.store?.name }}</span>
    </div>
  </div>
  <div
    *ngIf="storeInfo.store?.renovation?.openRenovationDate"
    class="row total-vacations-detail__title-row storeInfo__start">
    <div size="12" class="col total-vacations-detail__title no-padding">
      {{ 'MOT.VACATIONS.DETAIL.REFORM_START' | translate }}
    </div>
    <div size="12" class="col total-vacations-detail__description no-padding">
      <span>{{ storeInfo.store?.renovation?.openRenovationDate }} </span>
    </div>
  </div>
  <div
    *ngIf="storeInfo.store?.renovation?.closeRenovationDate"
    class="row total-vacations-detail__title-row storeInfo__end">
    <div size="12" class="col total-vacations-detail__title no-padding">
      {{ 'MOT.VACATIONS.DETAIL.REFORM_END' | translate }}
    </div>
    <div size="12" class="col total-vacations-detail__description no-padding">
      <span>{{ storeInfo.store?.renovation?.closeRenovationDate }} </span>
    </div>
  </div>
  <div *ngIf="storeInfo.observations?.general" class="row total-vacations-detail__title-row storeInfo__general">
    <div size="12" class="col total-vacations-detail__description no-padding">
      {{ 'MOT.VACATIONS.DETAIL.GENERAL_REMARKS' | translate }}
    </div>
    <div size="12" class="col total-vacations-detail__title no-padding">
      <span>{{ storeInfo.observations?.general }} </span>
    </div>
  </div>
</ng-template>

<ng-template #LastModifiedDate>
  <div class="row total-vacations-detail__title-row lastmodified">
    <div size="12" class="col total-vacations-detail__title no-padding">
      {{ 'MOT.VACATIONS.DETAIL.LASTMODIFIED' | translate }}
    </div>
    <div size="12" class="col total-vacations-detail__description no-padding">
      <span>{{ extraInfo?.lastModified }} </span>
    </div>
  </div>
</ng-template>
